import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { showErrorSnackbar } from 'components/shared/Snackbar';

import { REPORT_TYPES } from '../../type';
import {
  getReport,
  useHandleMultipleEndpointForReportSelection
} from './useGetAccessedReports';

export type ParamsToGetReport = {
  reportTypes?: REPORT_TYPES;
};

export const useGetNewReport = ({ reportTypes }: ParamsToGetReport) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const queryClient = useQueryClient();
  const baseType = useHandleMultipleEndpointForReportSelection(reportTypes);

  return useMutation(
    (data: any) => {
      return getReport({ baseType, reportTypes, requestParameters: data });
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['generated']
        });
      },
      onError: () => {
        showErrorSnackbar(
          t('notSuccessMsg', {
            name: reportTypes
          })
        );
      }
    }
  );
};
